import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, useRoutes } from "react-router-dom";
import AuthProvider from "./components/providers/auth-provider";
import ToastProvider from "./components/providers/toast-provider";
import { SidebarProvider } from "./contexts/sidebar-context";
import { useAuth } from "./hooks/use-auth";
import LoginPage from "./pages/auth/login-page";
import routes from "./router/config";

// Create query client instance
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5, // 5 minutes
			retry: 1,
		},
	},
});

function AppRoutes() {
	const { user, isLoading } = useAuth();
	const location = useLocation();
	const routing = useRoutes(routes);

	// Public routes that don't require authentication
	const publicRoutes = ["/login", "/terms", "/privacy", "/forgot-password", "/reset-password"];
	const isPublicRoute = publicRoutes.includes(location.pathname);

	if (isLoading) {
		return (
			<div className="min-h-screen bg-gray-50 flex items-center justify-center">
				<div className="text-center">
					<div className="w-16 h-16 bg-brand-100 rounded-full flex items-center justify-center mx-auto mb-4">
						<i className="ri-loader-4-line text-2xl text-brand-600 animate-spin"></i>
					</div>
					<p className="text-gray-600">Carregando...</p>
				</div>
			</div>
		);
	}

	// If not authenticated and not on a public route, redirect to login
	if (!user && !isPublicRoute) {
		return <LoginPage />;
	}

	return routing;
}

function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<BrowserRouter basename={__BASE_PATH__}>
				<SidebarProvider>
					<AuthProvider>
						<ToastProvider>
							<AppRoutes />
						</ToastProvider>
					</AuthProvider>
				</SidebarProvider>
			</BrowserRouter>
		</QueryClientProvider>
	);
}

export default App;
